// @generated da scripts/i18n-sr-cyrl.mjs — NON EDITARE A MANO.
// i18n area 'networks' — locale sr-Cyrl-RS: TRASLITTERAZIONE MECCANICA
// di networks.sr-Latn-RS.ts (srpska latinica). Ogni modifica va fatta
// sulla locale sr-Latn-RS e poi rigenerata con: node scripts/i18n-sr-cyrl.mjs
// Sidecar anti-stantie: ../meta/networks.sr-Cyrl-RS.meta.json.
import type { enUS } from './networks'

export const srCyrlRS: typeof enUS = {
  networks: {
    common: {
      name: 'Име',
      scope: 'Scope',
      operState: 'Стање',
      actions: 'Акције',
      create: 'Креирај',
      close: 'Затвори',
      cancel: 'Откажи',
      delete: 'Обриши',
      edit: 'Измени',
      save: 'Сачувај',
      editError: 'Измена није успела',
      search: 'Претражи по имену',
      empty: 'Још ничега овде',
      saveError: 'Није могуће сачувати',
      loadError: 'Није могуће учитати — да ли је TVirt backend доступан?',
      createError: 'Креирање није успело',
      deleteError: 'Брисање није успело',
      deleteConfirmTitle: 'Обрисати {name}?',
      deleteConfirmBody: 'Операција је неповратна.',
      nameHint: 'Мала слова, цифре и цртице (DNS-1123)',
      up: 'Активна',
      down: 'Неактивна',
      unknown: 'Непознато',
      usedByVMs: 'VM',
      emptyTable: 'Нема ставки — додајте једну дугметом +'
    },
    dialogTabs: {
      general: 'Опште',
      base: 'Основна дефиниција',
      advanced: 'Напредна конфигурација',
      reserved: 'Опсези резервисани за TVirt',
      position: 'Позиција',
      network: 'Мрежна конфигурација',
      hosts: 'Чворови учесници'
    },
    reservedRanges: {
      note: 'Ово су IP опсези резервисани за TVirt које он може користити да аутоматски додели адресу VM-овима, контејнерима итд. НАПОМЕНА: адресе из ових опсега не смеју ван TVirta користити спољни сервиси или уређаји.',
      from: 'Од',
      to: 'До'
    },
    overlay: {
      title: 'Overlay мреже',
      createTitle: 'Креирајте overlay мрежу',
      editTitle: 'Измените overlay мрежу',
      vni: 'VNI',
      vniHint: 'VXLAN Network Identifier — додељује се аутоматски ако је празно',
      subnet: 'Подмрежа',
      subnetHint: 'CIDR overlaya — IPAM из њега аутоматски изводи своју ставку регистра',
      mtu: 'MTU',
      weight: 'Тежина',
      ceilMbps: 'Плафон (Мбпс)',
      fairnessHint: 'Тежина важи само при загушењу: на слободној вези свака мрежа може да користи сав проток. Плафон важи увек.',
      contention: 'Надметање',
      contentionTip: 'Бар један чвор бележи одбацивања или оверлимит-е SA редом чекања на класи ове мреже: пропусни опсег уплинк-а је оспораван и тежине делују. Колико и откад пише у серијама нет.схапинг.* чвора.',
      firewallPolicy: 'Firewall политика',
      hosts: 'Хостови',
      hostsTitle: 'Чворови учесници',
      hostsHint: 'Сваки чвор декларише свој underlay endpoint — select над СТВАРНИМ адресама чвора, прочитаним из његове мрежне конфигурације; опциона overlay адреса мора бити унутар подмреже. Учешће је placement ограничење.',
      hostNode: 'Чвор',
      hostUnderlay: 'Underlay IP',
      hostUnderlayPickNode: 'Прво изаберите чвор',
      hostAddress: 'Адреса на overlayu (опционо)',
      hostAddressOutside: 'Изван подмреже overlaya ({cidr})',
      addHost: 'Додај чвор',

      // Round #156 (dialog standard): le righe osservate del dialog dettagli.
      observedAt: 'Посматрано',
      attachedNics: 'Прикачени NIC-ови'
    },
    services: {
      title: 'Мрежни сервиси',
      createTitle: 'Креирајте мрежни сервис',
      editTitle: 'Измените мрежни сервис',
      kind: 'Тип',
      kindCategory: 'Сервиси',
      selectKindHint: 'Изаберите тип сервиса — демон испод је имплементациони детаљ којим TVirt управља за вас.',
      kindLabel: {
        dhcp: 'DHCP сервер',
        ntp: 'NTP сервер',
        vpn: 'VPN сервер',
        dns: 'DNS сервер',
        gateway: 'Gateway',
        'lb-rp': 'Load balancer и reverse proxy',
        floatip: 'Плутајући IP'
      },
      kindDesc: {
        dhcp: 'Додељује адресе на подмрежама које служи — poolovi се изводе из подмреже, gatewaya и опсега мреже резервисаних за TVirt.',
        dns: 'Ауторитативни DNS над декларисаним зонама — записи се изводе из IPAM-а плус ваши ручни.',
        gateway: 'Чвор је gateway за мрежу — NAT (DNAT, 1:1, SNAT/masquerade) плус статичко рутирање између прикачених мрежа, самопоправљиво по дизајну.',
        'lb-rp': 'Балансер / обрнути прокси испред ваших сервиса — L4 или L7 слушаоци над пуловима чланова или над спремним инстанцама Под-а, реконфигурисани у лету.',
        ntp: 'Временски сервис мрежа — relay спољних upstream сервера, или сопствени сат чвора који се служи клијентима.',
        vpn: 'VPN концентратор на чвору — WireGuard или OpenVPN, по вашем избору: удаљени приступ за клијенте у покрету, или site то site тунел између две мреже.',
        floatip: 'Једна адреса која седи на само једној здравој App инстанци или Под-у одједном и сели се на следећи здрав циљ када овај падне — failover без демона; балансирање остаје балансеру.'
      },

      // Round Pod nativi P4: l'IP flottante (4b) e il backend Pod dell'lb-rp (4a).
      floatip: {
        hint: 'Плутајући IP живи на изабраној мрежи као DODATNA адреса унутар именског простора instance која га држи: без портова, без балансирања, без NAT-а — IP клијента остаје прави.',
        address: 'Плутајући IP',
        targets: 'Циљеви',
        targetsHint: 'Редоследом PREFERENCIJE: први здрав циљ држи адресу. Под важи за све своје instance, по реплици; сваки циљ има сопствени критеријум здравља. Сваки циљ мора бити повезан на исту мрежу.',
        targetKind: 'Циљ',
        targetApp: 'App инстанца',
        targetPod: 'Под (све instance)',
        targetRef: 'Који',
        health: 'Здравље',
        healthRunning: 'Ради (сваки контејнер спреман)',
        healthTcp: 'TCP веза',
        healthHttp: 'HTTP GET',
        healthPing: 'Пинг',
        port: 'Порт',
        path: 'Путања',
        addTarget: 'Додај циљ',
        moveUp: 'Помери горе',
        moveDown: 'Помери доле',
        preempt: 'Преемпт',
        preemptHint: 'Искључено (подразумевано): здрав држалац задржава адресу и када се виши циљ врати — без прескакања. Укључено: први здрав циљ је увек држи.',
        holder: 'Држалац',
        noHolder: 'нема здравог циља',
        since: 'од',
        verdicts: 'Посматрани циљеви',
        healthy: 'здрав',
        unhealthy: 'нездрав',
        noVerdict: 'Још није одлучено — чвор ауторитета уписује прву пресуду у следећем пролазу.',
        vipChip: 'VIP {address}',
        vipChipTooltip: 'Ова инстанца држи плутајући IP {address} сервиса {service}'
      },
      poolSource: 'Крајње тачке',
      poolSourceMembers: 'Статички чланови',
      poolSourcePod: 'Спремне instance Под-а',
      poolBackendPod: 'Под',
      poolBackendPort: 'Порт',
      poolBackendHint: 'Крајње тачке прате Под: инстанца улази када ради са сваким контејнером спремним, излази одмах када се смањи или умре. Активна провера је подразумевано укључена.',
      poolBackendCount: 'спремне instance Под-а {pod} на порту {port}',
      node: 'Чвор',
      enabled: 'Омогућен',
      parked: 'Паркиран',
      subnets: 'Подмреже',
      subnetsHint: 'IPAM подмреже које ова инстанца служи — poolovi се изводе из CIDR-а, gatewaya и опсега резервисаних за TVirt',
      noSubnets: 'Нема IPAM подмрежа — прво декларишите fabric логичку мрежу (или overlay подмрежу): IPAM се изводи из њих',
      iface: 'Интерфејс за слушање',
      ifaceHint: 'Хост интерфејс на којем сервис отвара свој socket (нпр. bridge) — обавезан: мрежни сервис је самосталан, „сви интерфејси“ више не постоје',
      dns: 'DNS сервери',
      domain: 'Домен',
      detail: 'Служи',
      subnetCount: 'подмрежа: {n}',
      zones: 'Зоне',
      zonesHint: 'Само ауторитативно — демон никада не рекурзира. А записи се изводе из декларисаних адреса чворова у референцираним IPAM подмрежама; прекидач reverse служи и одговарајуће in-addr.arpa зоне (PTR). Једну зону служи највише једна DNS инстанца у целој флоти. Опциони nameserver је FQDN уписан у NS/SOA записе уместо подразумеваног ns.<zona>; ако пада унутар зоне, његов А запис се свеједно изводи из чвора који је служи.',
      zoneName: 'Име зоне',
      zoneNs: 'Nameserver (NS)',
      zoneSubnets: 'IPAM подмреже',
      zoneReverse: 'Reverse (PTR)',
      zoneRecords: 'Ручни записи',
      zoneRecordsHint: 'Један по реду: име ТИП вредност — типови А, CNAME, MX, TXT. При колизији имена ручни запис побеђује изведени.',
      addZone: 'Додај зону',

      // lb-rp (wave 3 fondamenta): listener su pool inline — engine-less,
      // riconfigurato in volo.
      lbListeningHint: 'Инстанца декларише ЈЕДНУ мрежу за слушање и ЈЕДНУ адресу — сваки listener је везује на свом порту; друга адреса је други сервис.',
      listeners: 'Listeneri',
      listenersHint: 'Сваки listener везује адресу instance на свом порту у режиму L4 (TCP passthrough — бајтови се никада не отварају) или L7 (HTTP) и прослеђује ка једном од poolova испод. Пар адреса/порт служи највише једна инстанца по чвору. Измене се примењују у ходу — без restarta, без изгубљених конекција.',
      listenerName: 'Име',
      listenerMode: 'Режим',
      modeL7: 'L7 — HTTP reverse proxy',
      modeL4: 'L4 — TCP passthrough',
      listenerPort: 'Порт',
      listenerPool: 'Pool',
      addListener: 'Додај listener',
      pools: 'Poolovi',
      poolsHint: 'Backendi на које слеће саобраћај: статички чланови балансирани round-robin или по најмање заузетом, са опционом активном health check провером која болесне чланове избацује из ротације.',
      poolName: 'Име',
      poolAlgorithm: 'Алгоритам',
      algoRoundRobin: 'Round robin',
      algoLeastRequest: 'Најмање заузет',
      poolCheck: 'Health check',
      checkNone: 'Ниједан',
      checkTcp: 'TCP конекција',
      checkHttp: 'HTTP',
      poolCheckPath: 'Путања сонде',
      poolInterval: 'Интервал (с)',
      poolMembers: 'Чланови',
      poolMembersHint: 'Један по реду: адреса:порт, опционо праћен тежином (1-128) — нпр. 10.0.0.21:8080 2',
      addPool: 'Додај pool',
      memberCount: 'чланова: {n}',

      // ntp (round ntp — ratifica 2026-08-03, l'ultimo kind della famiglia):
      // il modo in parole parlate, la lista upstream solo dove significa
      // qualcosa, l'attacco di rete riusa le etichette del gateway.
      // #239 (netsvc autocontenuti): l'editor condiviso della lista di
      // listener dei kind dns e ntp — le due eccezioni multi-rete ratificate.
      listen: {
        assignment: 'Додела',
        assignmentStatic: 'Статичка адреса',
        assignmentAuto: 'Аутоматска (TVirt резервисани опсези)',
        autoHint: 'TVirt извлачи адресу из резервисаних опсега логичке мреже и држи је sticky — никад поново извучена при измени или failoveru.',
        title: 'Listeneri',
        hint: 'Мрежни сервис је самосталан: сваки listener декларише своју мрежу (overlay, fabric логичка мрежа или интерфејс) и адресу унутар њене подмреже — један listener по адреси, wildcard више не постоји. DNS и NTP могу слушати на више мрежа и на више адреса тих мрежа.',
        address: 'Адреса за слушање',
        add: 'Додај listener'
      },
      ntp: {
        mode: 'Режим синхронизације',
        modeRelay: 'Relay спољних сервера',
        modeNodeClock: 'Сопствени сат чвора',
        modeHint: 'Relay служи време узето са декларисаних upstream сервера; сопствени сат чвора служи време чвора који служи — које кластер ионако држи синхронизованим',
        servers: 'Upstream сервери',
        serversHint: 'Одвојени зарезом — hostname или IP адреса; сервис одавде узима време и служи га мрежи',
        port: 'Порт за слушање',
        listening: 'Слуша на'
      },

      vpn: {
        engine: 'Мотор',
        engineHint: 'Ви га бирате, и више се не мења: WireGuard је модеран, брз и у кернелу; OpenVPN је ветеран компатибилности (TCP, непријатељске мреже)',
        engineLocked: 'Мотор је непроменљив — други мотор је нови сервис, његови кључеви и сертификати нису преносиви',
        mode: 'Режим',
        modeRemote: 'Удаљени приступ',
        modeSite: 'Site то site',
        modeHint: 'Удаљени приступ даје клијентима у покрету адресу у тунелу; site то site спаја две мреже',
        port: 'Порт за слушање',
        protocol: 'Transport',
        protocolWireguardHint: 'WireGuard говори само UDP',
        tunnelSubnet: 'Подмрежа тунела',
        tunnelSubnetHint: 'Мрежа у којој живе клијенти — регистрована у IPAM регистру, настаје и умире са овим сервисом',
        dnsServers: 'DNS гурнут клијентима',
        routes: 'Руте гурнуте клијентима',
        routesHint: 'Мреже одвојене зарезом доступне кроз тунел; подмрежа тунела је увек укључена',
        peers: 'Peerovi',
        peersHint: 'Оставите јавни кључ празан и TVirt генерише пар — потом га испоручује уз профил. Налепите кључ и peer задржава свој.',
        clients: 'Клијенти',
        clientsHint: 'Сваки клијент добија сертификат издат од CA овог сервиса. Уклањање клијента га ОПОЗИВА: CRL се одмах регенерише.',
        peerName: 'Име',
        publicKey: 'Јавни кључ',
        publicKeyMinted: 'Генерише га TVirt',
        peerAddress: 'Адреса у тунелу',
        peerAddressHint: 'Празно = додељује се',
        allowedIps: 'Удаљене подмреже',
        allowedIpsHint: 'Одвојене зарезом, рутиране кроз овај peer',
        endpoint: 'Endpoint',
        presharedKey: 'Унапред дељени кључ',
        keepalive: 'Keepalive (с)',
        addPeer: 'Додај peer',
        addClient: 'Додај клијента',
        auth: 'Аутентификација',
        authTls: 'Сертификати (TLS)',
        remote: 'Удаљени endpoint',
        remoteHint: 'хост:порт удаљеног краја — празно значи да ова страна чека',
        peerRoutes: 'Удаљене подмреже',
        serverPublicKey: 'Јавни кључ овог сервера',
        ca: 'Сертификационо тело',
        listening: 'Слуша на',
        tunnel: 'Тунел',
        peerCount: 'peerova: {n}',
        download: 'Преузми профил',
        downloadError: 'Профил није било могуће извести',
        lastHandshake: 'Последњи handshake',
        never: 'никада',
        traffic: '↓ {rx} · ↑ {tx}',
        connected: 'Повезан',
        idle: 'Неактиван'
      },

      // Gateway (wave 3 — nato nat, ratifica 2026-08-01/02; rinominato ed
      // esteso il 2026-08-03): le tre famiglie di regole NAT più le rotte
      // statiche su una rete di listening. Ogni forma ratificata è supportata.
      gateway: {
        attach: 'Тип мреже за слушање',
        attachOverlay: 'Overlay мрежа',
        attachNetwork: 'Fabric логичка мрежа',
        attachInterface: 'Сирови интерфејс',
        overlay: 'Overlay мрежа',
        network: 'Логичка мрежа',
        interface: 'Име интерфејса',
        interfaceHint: 'Хост интерфејс којим TVirt не управља — адреса се узима на поверење',
        address: 'Адреса за слушање (gateway)',
        addressHint: 'Gateway адреса на коју клијенти показују — унутар подмреже мреже за слушање',
        dnatTitle: 'DNAT правила',
        dnatHint: 'Одредишни NAT: погођени саобраћај се преусмерава на нову адресу (и опционо нови порт). Било који протокол са листе — портови тамо где их протокол носи.',
        snatTitle: 'SNAT правила',
        snatHint: 'Изворни NAT: погођени саобраћај излази са преписаним извором — експлицитна нова адреса (и опционо нови порт), или masquerade на излазној адреси ако се остави празно.',
        oneToOneTitle: '1:1 NAT правила',
        oneToOneHint: 'Сваки пакет за спољну адресу пресликава се на унутрашњу, а унутрашњи хост излази као спољна — сви протоколи, оба смера.',
        external: 'Спољна адреса',
        internal: 'Унутрашња адреса',
        addOneToOne: 'Додај 1:1 правило',
        family: 'Фамилија',
        protocol: 'Протокол',
        source: 'Извор (адреса/подмрежа)',
        destination: 'Одредиште (адреса/подмрежа)',
        invert: 'NOT',
        srcPorts: 'Изворни портови',
        dstPorts: 'Одред. портови',
        dstPortsHint: 'Порт или опсег (80, 8000-8099)',
        toAddress: 'Нова адреса',
        toPort: 'Нови порт',
        snatTo: 'Нови извор (празно = masquerade)',
        snatToHint: 'Експлицитна изворна адреса; празно = masquerade на излазној адреси',
        addDnat: 'Додај DNAT правило',
        addSnat: 'Додај SNAT правило',
        routesTitle: 'Статичке руте',
        routesHint: 'Чвор рутира између мрежа на које је прикачен (IP forwarding је укључен); ове руте додају доступност изван њих — чист кернел, динамичко рутирање стиже са каснијим roundom.',
        routeDestination: 'Одредишна подмрежа',
        routeGateway: 'Next hop',
        routeMetric: 'Метрика',
        addRoute: 'Додај руту',
        listening: 'Слуша на',
        rules: 'DNAT: {d} · 1:1: {o} · SNAT: {s} · рута: {r}'
      },
      unknownSince: 'Непознато — последњи извештај пре {m} min',
      lastWord: 'Последња реч',

      // Round #156 (dialog standard): le righe osservate e il riepilogo in
      // sola lettura del blocco kind nel dialog dettagli.
      reportObservedAt: 'Последњи извештај',
      lastErrorRow: 'Последња грешка',
      recordsCount: 'ручних записа: {n}',
      phase: {
        configured: 'Конфигурисан',
        running: 'У току',
        error: 'Грешка'
      },
      authorityNode: 'Authority (додела)',
      preferredNode: 'Жељени чвор',
      preferredNodeHint: 'Мека преференција, никад ограничење: при следећој одлуци о placementu инстанца слеће овде ако је члан подобан — сама по себи не помера ништа; потез је „Пренеси authority".',
      noPreference: 'Без преференције (аутоматски placement)',
      moving: 'У покрету',
      movingTooltip: 'Посматран овде док authority додељује {node}: потез конвергира.',
      placement: {
        title: 'Placement',
        loading: 'Попис у току…',
        loadError: 'Попис placementa није одговорио — покушајте касније.',
        draftHint: 'Попис се рачуна над декларисаним мрежним прикључком: појавиће се када сервис буде направљен. Креирање се одбија када ниједан члан не може да га служи, а одбијање именује механизам који је испразнио скуп.',
        eligibleCount: '{n} од {m} чланова може да служи ову инстанцу',
        recommended: 'Препоручен',
        eligible: 'Подобан',
        notEligible: 'Није подобан',
        blockedReachability: 'мрежа не стиже до овог члана',
        blockedRequireTag: 'блокиран обавезним тагом (requireNodes)',
        blockedExcluded: 'искључен симулацијом',
        preferenceUnknown: 'није (више) члан кластера',
        preferenceIgnored: 'Преференција „{node}" данас није подобна: {reason}. Преовлађује препорука пописа — никад грешка, сервис живи другде.',
        emptyReachability: 'Ниједан члан не може да служи ову инстанцу: мрежа не стиже нигде — никаква измена тагова неће помоћи. Каблирајте чвор, или преместите сервис тамо где мрежа постоји.',
        emptyRequireTag: 'Ниједан члан не може да служи ову инстанцу: обавезни тагови су испразнили скуп — уклоните ставку из requireNodes, или тагујте члана.',
        spof: 'Јединствена тачка отказа',
        spofDetail: 'Само један члан може да угости инстанцу: при отказу failover нема куда. Multi-listener сервис се помера као CELINA — кандидат мора да види SVE његове мреже: то је цена.',
        whatIf: 'Симулирај одсутне чланове',
        whatIfHint: 'What-if дрена: питајте ПРЕ евакуације, не откривајте то при failoveru.',
        survives: 'Са одсутним {nodes} сервис и даље има дом.',
        notSurvives: 'Евакуација {nodes} оставља овај сервис OBOREN: изведено ограничење побеђује доступност (R30) — демон жив тамо где мрежа не стиже не служи никоме и не алармира никога.',
        transfer: 'Пренеси authority',
        transferError: 'Пренос није успео',
        transferTarget: 'Одредишни члан',
        transferHint: 'Нуде се само подобни чланови — преференција унутар важећег скупа, никад override. Без таска: следећи пролаз workera ЈЕСТЕ потез (стари чвор жање, нови рендерује).'
      }
    },
    fabric: {
      tabDerivation: 'Деривација',
      importNetwork: 'Увези из другог fabric-a',
      importTitle: 'Увези логичку мрежу',
      importHint: 'Увоз је изричито приступање: мрежа остаје власникова (исти идентитет, исти стем, исти bridge твф-<stem>) и одавде се мапира на портове/LAGG овог fabric-a — мапирати ZNAČI тврдити да испорука излази у исти L2 домен као власников.',
      importPick: 'Власникова мрежа',
      importNone: 'Нема шта да се увезе: други fabric-i немају сопствену мрежу коју овај fabric већ не познаје',
      importedNetworksTitle: 'Увезене мреже',
      noImported: 'Нема увезене мреже',
      importedFrom: 'увезена из {fabric}',
      importedBy: 'Увезена у: {list}',
      importedCount: '+{n} увезених',
      owner: 'Власник',
      bridge: 'Bridge',
      bond: 'Bond',
      unimport: 'Уклони увоз',
      unimportConfirm: 'Уклонити увоз мреже {name} (власник {fabric}) из овог fabric-a? Одбија се док је порт или LAGG овог fabric-a мапира, или док се гост, App или сервис опслужује само кроз ову ногу.',
      unimportRefused: 'Увоз је још у употреби — {detail}',
      deriv: {
        codeHint: {
          deviceHeldByFabric: 'Овај чвор већ узима ту мрежу из другог fabric-a чији је члан: чвор узима дељену мрежу само са JEDNE своје ноге (два уплинк-а истог L2 у bridge-u без STP-а су петља). Одмапирај је на портовима или LAGG-у једног од два fabric-a.',
          otherFabricDerived: 'Документ носи блок fabric-a према којем чвор више не декларише кабл: прво примени план тог fabric-a (предлаже уклањање његових уређаја), или их преузми са take-ownership ако fabric више не постоји.'
        },
        hint: 'План деривације О.3: за сваки ожичени чвор стање, дифф изведено-вс-тренутно, DEKLARISANA топологија bondova, дуал-стацк флипови и структурисана одбијања/упозорења. Само за читање до EKSPLICITNOG apply-a — ништа никада не слеће на чвор само.',
        refresh: 'Поново учитај план',
        empty: 'Ниједан чвор није ожичен на овај fabric (и ниједан више не носи његов блок).',
        refusal: 'Одбијање',
        warning: 'Упозорење',
        generation: 'генерација документа {n}',
        state: {
          manual: 'Ручни',
          derived: 'Изведен',
          diverged: 'Одступљен'
        },
        topologyTitle: 'Декларисана топологија',
        members: 'чланови',
        primary: 'примарни',
        held: 'држан на JEDNOM члану',
        form: {
          perNetworkBond: 'Bond по мрежи',
          singleBond: 'Један резервни bond',
          laggBond: 'LACP bond (LAGG)',
          singlePort: 'Један порт'
        },
        colAction: 'Радња',
        colKind: 'Врста',
        colDevice: 'Device',
        colDetail: 'Детаљ',
        action: {
          add: 'додај',
          remove: 'уклони',
          replace: 'замени'
        },
        diffEmpty: 'Нема чекајућег диффа — примењени документ се поклапа са рендером.',
        diffBlocked: 'Нема диффа: горња одбијања блокирају овај чвор.',
        phasePlanned: 'планирано (корак 1 од 3)',
        phaseDraining: 'празни се (корак 2 од 3)',
        probeUnobserved: 'Сонда пражњења: никад пријављена — празнина је NEPOZNATA (ретире би сада био одбијен).',
        probeFailed: 'Сонда пражњења: посматрање NEUSPELO — познате временске ознаке се преносе, никад «празно» које нико није измерио.',
        probeActive: {
          one: 'Сонда: {n} успостављена веза још на старој адреси',
          few: 'Сонда: {n} успостављене везе још на старој адреси',
          other: 'Сонда: {n} успостављених веза још на старој адреси'
        },
        probeLastActive: 'последња активност {time}',
        probeEmpty: {
          one: 'Сонда: празно {n} минут',
          few: 'Сонда: празно {n} минута',
          other: 'Сонда: празно {n} минута'
        },
        probeEmptyUnknown: 'Сонда: празно (откад, непознато).',
        impact: '{nics} vNIC и {apps} App на овом чвору користе ове мреже: {list}',
        apply: 'Примени на овај чвор',
        applyTitle: 'Примени деривацију — {node}',
        applyIntro: 'Изведена конфигурација преписује мрежни документ чвора {node} ({n} промена) кроз иста врата као editor host-network — укључујући NetworkManager checkpoint и поштену сонду. Упозорења плана испод путују са чином: прочитајте их пре потврде.',
        applyError: 'Apply није успео',
        applyRefused: 'Чвор је одбио:',
        planMoved: 'Fabric се променио после овог прегледа — NIŠTA није примењено. План је поново учитан: погледајте поново и покушајте опет.',
        retire: 'Повуци',
        retireTitle: 'Тачка без повратка — повлачење {address}',
        restore: 'Врати',
        restoreTip: 'Назад на снимак пре apply-a (генерација {previous}) — поништавање у једном кораку (H13)',
        restoreTitle: 'Врати претходни документ — {node}',
        restoreIntro: 'Мрежни документ чвора {node} враћа се на снимак направљен пре последњег apply-a (генерација {previous}), уписан као генерација {next} уместо {current}. Worker га усклађује као сваки други документ.',
        restoreRedo: 'Замењени документ постаје нови снимак: поновно враћање је редо.',
        restoreClosesChain: 'Снимак је ручни документ пре деривације: ланац се овде затвара — нема даљег поништавања, чвор је ручни до следећег apply-a.',
        restoreConfirm: 'Врати',
        restoreError: 'Враћање није успело',
        retireIntro: 'Ово дефинитивно уклања {address} ({network}) са {point}. После овог чина пут назад је OBRNUTI флип — поновна декларација старе адресе кроз исти мотор — никад слепа обнова.',
        retireOld: 'Стара адреса (уклоњена)',
        retireNew: 'Нова адреса (остаје)',
        retireEmptyFact: 'Сонда пражњења јавља адресу празном: ово уклањање не прекида ниједну посматрану везу.',
        retireConfirm: 'Повуци адресу',
        severActiveLoss: {
          one: 'Прекини {n} успостављену везу још на старој адреси — умире са овим чином',
          few: 'Прекини {n} успостављене везе још на старој адреси — умиру са овим чином',
          other: 'Прекини {n} успостављених веза још на старој адреси — умиру са овим чином'
        },
        severUnknownLoss: 'Прихвати NEPOZNATO: сонда никад није посматрала ову адресу (или посматрање не успева) — живе везе могу бити прекинуте.'
      },
      title: 'Fabric',
      createTitle: 'Креирајте fabric',
      networks: 'Мреже',
      switches: 'Switchevi',
      ports: 'Портови',
      laggs: 'LAGG-ови',
      subnets: 'Подмреже',
      tabOverview: 'Преглед',
      tabNetworks: 'Логичке мреже',
      tabSwitches: 'Switchevi',
      overviewHint: 'Fabric на први поглед: свака логичка мрежа са својим MTU и подмрежом (VLAN-ови живе само у мапирањима по порту/по LAGG-у — иста мрежа може путовати са различитим таговима на различитим портовима). Fabric је регистар СПОЉНЕ инфраструктуре — TVirt посматра и декларише, никада не врши provisioning, и додирује само NIC-ове регистроване под његовом контролом.',
      absorptionHint: 'Свака подмрежа декларисана овде ИЗВОДИ своју ставку у IPAM регистру у истом упису — живи и умире са мрежом.',
      scopeFixedHint: 'Scope је фиксиран на корен кластера: физичка инфраструктура је по дефиницији на нивоу целог кластера.',
      networksHint: 'Свака мрежа носи обавезан MTU (подразумевано 1500) и обавезну подмрежу; gateway, DNS сервери и статичке руте декларисани овде су ЈЕДИНИ ИЗВОР за NIC-ове сервера, Апликације и мрежне сервисе.',
      switchesHint: 'Ручни регистар: порт је некоришћен, мапиран (untagged и саобраћај по VLAN тагу на логичке мреже) или члан LAGG-а — члан не носи сопствена мапирања.',
      mtu: 'MTU',
      cidr: 'CIDR',
      cidrHint: 'Обавезан — IPAM из њега аутоматски изводи своју ставку регистра',
      nodeAddressing: 'Адресирање чворова',
      nodeAddressingNone: 'Ништа — без адресе по чвору',
      nodeAddressingPool: 'Pool — једна трајна адреса по опслуженом чвору',
      nodeAddressingHint: 'Са Pool деривација фабрика сваком опслуженом чвору додељује адресу из опсега резервисаних за TVirt (трајна након доделе).',
      backing: 'Backing',
      gateway: 'Gateway',
      ranges: 'Резервисани опсези',
      dns: 'DNS сервери (одвојени зарезом)',
      dnsShort: 'DNS',
      singleSourceHint: 'Gateway, DNS и руте декларисани овде су једини извор — NIC-ови сервера, Апликације и мрежни сервиси црпе одавде',
      routesTitle: 'Статичке руте',
      routeDestination: 'Одредиште (CIDR)',
      routeVia: 'Преко (next hop)',
      portUsed: 'Коришћен',
      vlanMappings: 'VLAN мапирања',
      vlanTag: 'VLAN таг',
      vlanNetwork: 'Логичка мрежа',
      nameTaken: 'Име је већ употребљено у fabricu',
      addNetwork: 'Додај мрежу',
      editNetwork: 'Измени мрежу',
      deleteNetwork: 'Уклони мрежу',
      deleteNetworkConfirm: 'Уклонити логичку мрежу {name} из fabrica? Њена изведена IPAM подмрежа умире са њом (одбија се док је неки сервис или Апликација још користи). Мапирања на портовима и LAGG-овима која показују на њу биће уклоњена.',
      switchName: 'Switch',
      portName: 'Порт',
      positionHint: 'Физичка позиција (опционо) — исти речник као за позиционирање сервера; само декларативно',
      addSwitch: 'Додај switch',
      editSwitch: 'Измени switch',
      deleteSwitch: 'Уклони switch',
      deleteSwitchConfirm: 'Уклонити switch {name} са свим његовим портовима? LAGG-ови се сходно скупљају (и умиру испод два порта).',
      addPort: 'Додај порт',
      editPort: 'Измени порт',
      deletePort: 'Уклони порт',
      deletePortConfirm: 'Уклонити порт {name}?',
      untagged: 'Untagged',
      tagged: 'Tagged (таг:мрежа)',
      taggedShort: 'Tagged',
      portCabling: 'Каблирање',
      portState: 'Стање',
      stateUnused: 'некоришћен',
      stateMapped: 'мапиран',
      laggPortGuard: 'Порт који је члан LAGG-а мења се са LAGG стране',
      laggsTitle: 'LAGG-ови',
      laggsHint: 'LAGG је 2+ порта у LACP-у и може се протезати преко више switcheva (MLAG, транспарентно); улазе само некоришћени портови, LAGG је површина мапирања, уклоњени порт се враћа у некоришћене.',
      addLagg: 'Додај LAGG',
      editLagg: 'Измени LAGG',
      deleteLagg: 'Уклони LAGG',
      deleteLaggConfirm: 'Уклонити LAGG {name}? Његови портови чланови враћају се у некоришћене.',
      lacpRate: 'LACP rate',
      laggPorts: 'Портови чланови (2+)',
      laggPortsHint: 'Улазе само некоришћени портови — прво ослободите мапирани порт',
      noNetworks: 'Ниједна логичка мрежа није декларисана.',
      noSwitches: 'Ниједан switch није декларисан.',
      noLaggs: 'Ниједан LAGG није декларисан.',
      staleConflict: 'Други оператер је променио овај fabric док си га уређивао: чување је одбијено да се не обрише његов рад. Твоје измене су и даље овде, нетакнуте. Ажурирани fabric је већ поново учитан: потврди поново да их примениш преко њега, или одустани и погледај шта се променило.'
    },
    ipam: {
      title: 'IPAM',
      derivedHint: 'Само изведено: свака подмрежа настаје из fabric логичке мреже или из overlaya — мења се на извору. Додељене адресе показују КО их држи; опсези резервисани за TVirt су poolovi аутоматске доделе.',
      search: 'Претрага по имену, CIDR-у или адреси',
      empty: 'Нема мрежа — декларишите fabric логичку мрежу или overlay подмрежу: IPAM се из њих изводи аутоматски.',
      reserved: 'Опсези резервисани за TVirt',
      address: 'Адреса',
      origin: 'Порекло',
      origin_declared: 'декларисано',
      origin_observed: 'посматрано',
      holder: 'Држи је',
      noAddresses: 'Ниједна адреса у овој подмрежи још није позната.',
      sourceFabric: 'Fabric',
      sourceOverlay: 'Overlay',
      editAtSource: 'Измени на извору'
    },

    // Rete > Firewall (#168): il vocabolario dei gruppi + la terna per-NIC.
    firewall: {
      title: 'Firewall групе',
      createTitle: 'Нова firewall група',
      editTitle: 'Измените firewall групу',
      empty: 'Још нема firewall група — направи једну: речник правила за вишекратну употребу, на који се guest NIC-ови позивају по имену.',
      nameHint: 'Слова, цифре и . - _ у средини; јединствено унутар свог scopea (истоимени се другде разликују по /scope/име)',
      description: 'Опис',
      descriptionHint: 'Један ред намере, приказан свуда где се група бира',
      enforced: 'Наметнуто scopeu',
      enforcedHint: 'Искључено: чист речник — правила везују само NIC-ове који се позивају на групу. Укључено: правила везују сваки guest NIC са укљученим firewallom под scopeom групе, са референцом или без ње.',
      enforcedChip: 'Наметнуто',
      enforcedChipHint: 'Правила везују сваки guest NIC са укљученим firewallom под scopeom групе, са референцом или без ње',
      enforceWarning: 'Укључивањем наметања правила при следећем усклађивању везују СВАКИ guest NIC са укљученим firewallom под {scope}, и без изричите референце — а унутар активног цхаина дроп претка је коначан: нивои испод га не отварају поново.',
      unenforceInfo: 'Уклањањем наметања правила остају само на NIC-овима који се изричито позивају на групу.',
      rules: 'Правила',
      tabOverview: 'Преглед',
      tabRules: 'Правила',
      orderHint: 'Редослед редова ЈЕСТЕ редослед вредновања унутар групе: побеђује прво правило које се поклапа.',
      statefulHint: 'Статефул је имплицитан: одговори на допуштени саобраћај пролазе сами (естаблисхед/релатед се прихватају, инвалид се одбацује — убацује их мотор, не пишу се ручно).',
      noRules: 'Нема правила — речник у изградњи: позивање на њега је дозвољено и не производи ништа.',
      addRule: 'Додај правило',
      direction: 'Смер',
      directionIn: 'Улазни',
      directionOut: 'Излазни',
      action: 'Акција',
      action_accept: 'Прихвати',
      action_drop: 'Одбаци',
      action_reject: 'Одбиј',
      protocol: 'Протокол',
      protocolAny: 'Било који',
      ports: 'Портови',
      source: 'Извор',
      dest: 'Одредиште',
      comment: 'Коментар',
      addressHint: 'IPv4 CIDR или <fabric>/<logička mreža>; празно = било која',
      moveUp: 'Помери горе',
      moveDown: 'Помери доле',
      nicFirewall: 'Firewall',
      nicAntiSpoof: 'Анти-споофинг',
      nicGroups: 'Firewall групе',
      nicGroupsPlaceholder: 'Изабери групу…',
      nicGroupsHint: 'Видљиве групе, укључујући оне надређених scopeova (употребљиве надоле, као тагови)',
      nicGroupCount: { one: '{n} firewall група', few: '{n} firewall групе', other: '{n} firewall група' },
      nicOff: 'Firewall искључен',
      pendingRestartHint: 'Измене firewalla следе модел сачувано/примењено: чекају следећи power cycle (PendingRestart). Групе наметнуте од надређених scopeova примењују се кад је firewall NIC-а укључен.',
      appConvergeHint: 'Измене firewalla примењују се при следећем усклађивању контејнера. Групе наметнуте од надређених scopeova примењују се кад је firewall укључен.',
      enforcedAncestors: 'Наметнуте од надређених scopeova',
      enforcedAncestorsHint: 'Ова група се примењује на сваки NIC под својим scopeom са UKLJUČENIM firewallom — прекидач је главни прекидач NIC-а (искључено = никакав цхаин, преци укључени); унутар активног цхаина ауторитет претка је коначан: његов дроп се испод не отвара поново.'
    }
  }
}
